module.exports = __webpack_public_path__ + "static/media/sr-CS.a203597c.md";